import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getAirplaneModelList(params) {
  return request({
    url: URL.mdm.basicData.airplaneModel,
    method: 'get',
    params
  })
}

export function getNoPaginationAirplaneModelList(params) {
  return request({
    url: URL.mdm.basicData.allAirplaneModel,
    method: 'get',
    params
  })
}

export function getAirplaneModelsByPlatform(params) {
  return request({
    url: URL.mdm.basicData.platformAirplaneModel,
    method: 'get',
    params
  })
}

export function getAllAirplaneModelTemplate(params) {
  return request({
    url: URL.mdm.basicData.airplaneModelTemplate,
    method: 'get',
    params
  })
}

export function saveAirplaneModel(data) {
  return request({
    url: URL.mdm.basicData.airplaneModel,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function addAirplaneModelByPlatform(data) {
  return request({
    url: URL.mdm.basicData.platformAirplaneModel,
    method: 'post',
    data
  })
}

export function saveAirplaneModels(data) {
  return request({
    url: URL.mdm.basicData.airplaneModels,
    method: 'post',
    data
  })
}

export function delAirplaneModel(data) {
  return request({
    url: URL.mdm.basicData.delAirplaneModel,
    method: 'post',
    data
  })
}
